'use strict';

exports.__esModule = true;
exports.default = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _components = require('components');

var _survey = require('redux/modules/survey');

var _client = require('redux/modules/client');

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _mozart_ui = require('@pgforsta/mozart_ui');

var _utilElement = require('utils/util-element.js');

var _utilConstants = require('utils/util-constants.js');

var _utilsStyles = require('../../utils/utils-styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Survey = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    survey: state.survey.data,
    locations: state.survey.locations,
    surveys: state.survey.list,
    clientDetails: state.client,
    selectedLanguage: state.survey.selectedLanguage,
    apiRouter: state.survey
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ loadSurvey: _survey.loadSurvey, setLanguage: _survey.setLanguage, loadLocations: _survey.loadLocations, loadSurveys: _survey.loadSurveys, saveFeedback: _survey.saveFeedback, loadAudienceInfo: _survey.loadAudienceInfo, loadClient: _client.loadClient }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Survey, _Component);

  function Survey(props) {
    (0, _classCallCheck3.default)(this, Survey);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = require('./Survey.scss');
    _this.state = {
      start_survey: false,
      location_id: parseInt(_this.props.params.locationId, 10) ? _this.props.params.locationId : 0,
      survey_id: parseInt(_this.props.params.surveyId, 10) ? _this.props.params.surveyId : 0,
      provider_id: parseInt(_this.props.params.providerId, 10) ? _this.props.params.providerId : 0,
      audience_code: _this.props.params.code && _this.props.params.code !== '0' ? _this.props.params.code : 0,
      language_id: false,
      tmp_location: 0,
      tmp_survey: 0,
      tmp_language: 0,
      show_locations: false,
      show_surveys: false,
      show_languages: false,
      current_page: '',
      current_move: 'forward',
      show_back: false,
      show_next: true,
      seq_no: 0,
      show_thankyou: false,
      preview_mode: _this.props.location.query && _this.props.location.query.previewMode && _this.props.location.query.previewMode === 'on' ? true : false,
      redirect_from_thankyou: _this.props.location.query && _this.props.location.query.officeMode && _this.props.location.query.officeMode === 'on' ? true : false,
      track_click: _this.props.location.query && _this.props.location.query.trackClick && _this.props.location.query.trackClick === 'on' ? true : false,
      client_logo_url: 'https://' + window.env.nextgenApiHost + '/api/clients/' + _this.props.params.clientId + '/logo?productId=' + _utilConstants.PRODUCT_CAMPAIGN,
      show_branding: true,
      show_loading: true,
      show_search_page: false,
      survey_submitted: false,
      location_label: 'Please select a practice/location',
      theme: {
        colorCode: '#00397AFF',
        surveyColorType: 'presetColor',
        colorTheme: 'darkBlue',
        customTextColor: '#FFFFFF'
      }
    };
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_PAGE_LOAD, _utilElement.EVENT_PAGE_LOAD, 'Loading home page.');
    return _this;
  }

  Survey.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var clientId = this.props.params.clientId;
    this.props.loadClient(clientId).then(function (clientDetails) {
      var additionalConfig = clientDetails && clientDetails.additionalConfiguration ? clientDetails.additionalConfiguration : [];
      var theme = {};
      additionalConfig.map(function (item) {
        if (item.key === 'surveyColorType' || item.key === 'colorCode' || item.key === 'colorTheme' || item.key === 'customTextColor') {
          theme[item.key] = item.value;
        }
        return theme;
      });

      _this2.setState({ theme: theme });
      var style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = (0, _utilsStyles.loaderOverride)(theme.colorCode) + '  ' + (0, _utilsStyles.buttonOverride)(theme.colorCode, theme.customTextColor);
      document.getElementsByTagName('head')[0].appendChild(style);
      if (_this2.state.audience_code) {
        _this2.props.loadAudienceInfo(clientId, _this2.state.audience_code, _this2.state.track_click).then(function (audienceInfo) {
          if (audienceInfo && audienceInfo.data) {
            if (audienceInfo.data.hasSurveySubmitted) {
              _this2.props.loadSurvey(clientId, _this2.state.survey_id, _this2.state.location_id, _this2.state.audience_code ? _this2.state.audience_code : '').then(function (surveyData) {
                if (surveyData && surveyData.data) {
                  _this2.configureSurvey(surveyData.data);
                  _this2.setState({ show_thankyou: true, start_survey: false, survey_submitted: true });
                }
              });
            } else {
              _this2.loadPreFillData();
            }
          }
        });
      } else {
        _this2.loadPreFillData();
      }
    });
  };

  Survey.prototype.onSurveySubmit = function onSurveySubmit(surveyData, anonymousFlag) {
    var _this3 = this;

    var clientId = this.props.params.clientId;
    var surveyInput = this.prepareSurveyData(surveyData, anonymousFlag);
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_BTN_CLICK, _utilElement.EVENT_BTN_CLICK, 'Feedback submitting with data : ' + (0, _stringify2.default)(surveyInput));
    if (this.state.preview_mode) {
      console.log("You are in preview mode, so submission won't happen");
      console.log(_momentTimezone2.default.utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'));
      this.setState({ show_thankyou: true, start_survey: false });
    } else {
      this.props.saveFeedback(clientId, surveyInput).then(function () {
        _this3.setState({ show_thankyou: true, start_survey: false });
      });
    }
  };

  Survey.prototype.getPrePageContent = function getPrePageContent() {
    return _react2.default.createElement(
      'div',
      null,
      this.showLocations() && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.Locations, {
          selectedLocation: this.state.location_id,
          key: Math.random(),
          onSelectLocation: this.selectLocation.bind(this),
          clientId: this.props.params.clientId,
          sourceId: this.state.survey_id,
          showSearch: this.state.show_search_page,
          theme: this.state.theme,
          label: this.state.location_label
        })
      ),
      !this.showLocations() && this.showSurveys() && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.Surveys, {
          selectedSurvey: this.state.survey_id,
          key: Math.random(),
          onSelectSurvey: this.selectSurvey.bind(this),
          clientId: this.props.params.clientId,
          locationId: this.state.location_id,
          showSearch: this.state.show_search_page,
          previewMode: this.state.preview_mode,
          theme: this.state.theme
        })
      ),
      !this.showLocations() && !this.showSurveys() && this.showLanguages() && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.Languages, {
          currentLanguage: this.state.language_id,
          key: Math.random(),
          onSelectLanguage: this.selectLanguage.bind(this),
          showSearch: this.state.show_search_page,
          theme: this.state.theme
        })
      )
    );
  };

  Survey.prototype.getMobileFriendlySurvey = function getMobileFriendlySurvey(surveyList) {
    var _this4 = this;

    var mobileFriendlySurveys = [];
    if (surveyList) {
      surveyList.map(function (item) {
        if (_this4.state.preview_mode) {
          mobileFriendlySurveys.push(item);
        } else if (item.mobileFriendly) {
          mobileFriendlySurveys.push(item);
        }
      });
    }
    return mobileFriendlySurveys;
  };

  Survey.prototype.generateUUID = function generateUUID() {
    var date = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (clbk) {
      var replace = (date + Math.random() * 16) % 16 | 0;
      date = Math.floor(date / 16);
      return (clbk === 'x' ? replace : replace & 0x3 | 0x8).toString(16);
    });
    return uuid;
  };

  Survey.prototype.prepareSurveyData = function prepareSurveyData(surveyData, anonymousFlag) {
    var surveyInput = {};
    var clientId = this.props.params.clientId;

    surveyInput.avatarId = this.state.location_id;
    surveyInput.campaignAudienceCode = this.state.audience_code ? this.state.audience_code : '';
    surveyInput.clientId = clientId;
    surveyInput.fromCampaign = this.state.audience_code ? true : false;
    surveyInput.language = this.state.language_id;
    surveyInput.mentionTime = _momentTimezone2.default.utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]');
    surveyInput.sessionKey = this.generateUUID();
    surveyInput.sourceId = this.state.survey_id;
    surveyInput.anonymousFlag = anonymousFlag;
    surveyInput.surveyresponses = [];
    if (this.state.preview_mode) {
      surveyInput.previewMode = 'ON';
    }

    if ((0, _keys2.default)(surveyData).length > 0) {
      (0, _keys2.default)(surveyData).map(function (item) {
        var responses = [];
        if ((0, _typeof3.default)(surveyData[item].optionId) === 'object') {
          var optionList = surveyData[item].optionId;
          var responseList = surveyData[item].response;
          optionList.map(function (optionitem, index) {
            responses.push({ optionId: optionitem, response: responseList[index] });
          });
        } else {
          responses.push({ optionId: surveyData[item].optionId, response: surveyData[item].response });
        }
        surveyInput.surveyresponses.push({ questionId: item, responses: responses });
      });
    }

    return surveyInput;
  };

  Survey.prototype.loadPreFillData = function loadPreFillData() {
    var _this5 = this;

    var clientId = this.props.params.clientId;
    // Load location list
    if (!this.props.locations && !parseInt(this.props.params.locationId, 10)) {
      this.props.loadLocations(clientId, this.state.survey_id).then(function (locationData) {
        if (locationData && locationData.data && locationData.data.length === 1) {
          _this5.setState({
            location_id: locationData.data[0].id,
            show_locations: false,
            tmp_location: locationData.data[0].id }, function () {
            _this5.handleNextButtonClick();
          });
        } else {
          _this5.setState({ location_id: 0, show_locations: true });
        }
      });
    }
    // Load Survey list
    if (this.state.location_id && !this.props.surveys && !parseInt(this.props.params.surveyId, 10)) {
      this.props.loadSurveys(clientId, this.state.location_id).then(function (surveyListData) {
        if (surveyListData && surveyListData.data && _this5.getMobileFriendlySurvey(surveyListData.data).length === 1) {
          _this5.setState({
            survey_id: _this5.getMobileFriendlySurvey(surveyListData.data)[0].id,
            show_surveys: false,
            tmp_survey: surveyListData.data[0].id }, function () {
            _this5.handleNextButtonClick();
          });
        } else {
          _this5.setState({ survey_id: 0, show_surveys: true });
        }
      });
    }
    // Load survey info
    if (!this.props.survey && this.state.survey_id) {
      this.props.loadSurvey(clientId, this.state.survey_id, this.state.location_id, this.state.audience_code ? this.state.audience_code : '').then(function (surveyData) {
        if (surveyData && surveyData.data) {
          _this5.configureSurvey(surveyData.data);
        }
      });
    }
  };

  Survey.prototype.showLocations = function showLocations() {
    var retVal = false;
    if (!this.defaultLocationId() && this.state.show_locations) {
      this.state.current_page = 'location';
      this.state.tmp_location = this.state.location_id;
      this.state.show_back = false;
      if (this.state.tmp_location) {
        this.state.show_next = true;
      } else {
        this.state.show_next = false;
      }
      retVal = true;
    } else {
      this.state.show_next = false;
    }
    return retVal;
  };

  Survey.prototype.showSurveys = function showSurveys() {
    var retVal = false;
    if (this.state.location_id && !this.defaultSurveyId() && this.state.show_surveys) {
      this.state.current_page = 'survey';
      this.state.tmp_survey = this.state.survey_id;
      this.state.show_back = !this.defaultLocationId() && this.props.locations && this.props.locations.length !== 1;
      this.state.show_next = this.props.surveys && this.props.surveys.data.length && this.state.tmp_survey ? true : false;
      retVal = true;
    } else {
      this.state.show_next = false;
    }
    return retVal;
  };

  Survey.prototype.showLanguages = function showLanguages() {
    var retVal = false;
    if (this.state.location_id && this.state.survey_id && this.state.show_languages) {
      this.state.current_page = 'language';
      this.state.tmp_language = this.state.language_id;
      this.state.show_back = (!this.defaultSurveyId() || !this.defaultLocationId()) && this.props.surveys && this.props.surveys.length !== 1;
      retVal = true;
    }
    return retVal;
  };

  Survey.prototype.startSurvey = function startSurvey() {
    this.setState({ start_survey: true });
  };

  Survey.prototype.selectLocation = function selectLocation(location) {
    var _this6 = this;

    this.state.tmp_location = location.id;
    this.state.location_id = location.id;
    this.state.show_next = true;
    this.state.show_search_page = false;
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_SET_DATA, _utilElement.EVENT_SET_DATA, 'Location selected : ' + location.id);
    this.setState({
      location_id: this.state.location_id
    }, function () {
      _this6.handleNextButtonClick();
    });
  };

  Survey.prototype.selectSurvey = function selectSurvey(survey) {
    var _this7 = this;

    this.state.tmp_survey = survey.id;
    this.state.survey_id = survey.id;
    this.state.show_next = true;
    this.state.show_search_page = false;
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_SET_DATA, _utilElement.EVENT_SET_DATA, 'Survey selected : ' + survey.id);
    this.setState({
      survey_id: this.state.survey_id
    }, function () {
      _this7.handleNextButtonClick();
    });
  };

  Survey.prototype.selectLanguage = function selectLanguage(language) {
    var _this8 = this;

    this.state.tmp_language = language;
    this.state.language_id = language;
    this.state.show_next = true;
    this.state.show_search_page = false;
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_SET_DATA, _utilElement.EVENT_SET_DATA, 'Language selected : ' + language);
    this.setState({
      language_id: this.state.language_id
    }, function () {
      _this8.handleNextButtonClick();
    });
  };

  Survey.prototype.defaultSurveyId = function defaultSurveyId() {
    return parseInt(this.props.params.surveyId, 10);
  };

  Survey.prototype.defaultLocationId = function defaultLocationId() {
    return parseInt(this.props.params.locationId, 10);
  };

  Survey.prototype.configureSurvey = function configureSurvey(survey) {
    this.state.show_branding = survey.showBFBranding;
    this.state.start_survey = !survey.showStartSurveyPage;

    if (survey.showLocationBasedLogo) {
      this.state.client_logo_url = this.state.client_logo_url.split('?')[0];
      this.state.client_logo_url = this.state.client_logo_url + '?avatarId=' + this.state.location_id + '&productId=' + _utilConstants.PRODUCT_CAMPAIGN;
    } else {
      this.state.client_logo_url = this.state.client_logo_url.split('?')[0];
      this.state.client_logo_url = this.state.client_logo_url + '?productId=' + _utilConstants.PRODUCT_CAMPAIGN;
    }
    if (survey.languages && (0, _keys2.default)(survey.languages).length === 1) {
      this.state.language_id = (0, _keys2.default)(survey.languages)[0];
      this.state.show_languages = false;
      this.props.setLanguage((0, _keys2.default)(survey.languages)[0]);
    } else {
      this.state.language_id = 0;
      this.state.show_languages = true;
    }
    if (survey.locationLabel) {
      this.state.location_label = survey.locationLabel;
    }
    this.setState({ language_id: this.state.language_id });
  };

  Survey.prototype.loadSurveyList = function loadSurveyList() {
    var _this9 = this;

    this.props.loadSurveys(this.props.params.clientId, this.state.location_id).then(function (surveyListData) {
      if (surveyListData && surveyListData.data && _this9.getMobileFriendlySurvey(surveyListData.data).length === 1) {
        _this9.state.survey_id = _this9.getMobileFriendlySurvey(surveyListData.data)[0].id;
        _this9.state.tmp_survey = _this9.getMobileFriendlySurvey(surveyListData.data)[0].id;
        _this9.state.show_surveys = false;
        _this9.loadSurveyInfo();
      } else {
        _this9.state.survey_id = 0;
        _this9.state.show_surveys = true;
      }
      _this9.state.show_locations = false;
      if (_this9.state.preview_mode) {
        _this9.state.show_surveys = !_this9.defaultSurveyId() && _this9.props.surveys && _this9.props.surveys.data.length !== 1;
      } else {
        _this9.state.show_surveys = !_this9.defaultSurveyId() && _this9.props.surveys && _this9.getMobileFriendlySurvey(surveyListData.data).length !== 1;
      }
      _this9.state.show_languages = _this9.defaultSurveyId() && _this9.props.survey && (0, _keys2.default)(_this9.props.survey.data.languages).length !== 1;
      _this9.setState({ location_id: _this9.state.tmp_location, tmp_location: 0, current_move: 'forward' });
    });
  };

  Survey.prototype.loadSurveyInfo = function loadSurveyInfo() {
    var _this10 = this;

    this.props.loadSurvey(this.props.params.clientId, this.state.survey_id, this.state.location_id, this.state.audience_code ? this.state.audience_code : '').then(function (surveyData) {
      if (surveyData && surveyData.data) {
        _this10.configureSurvey(surveyData.data);
      }
      _this10.state.show_locations = false;
      _this10.state.show_surveys = false;
      _this10.state.show_languages = _this10.props.survey && (0, _keys2.default)(_this10.props.survey.data.languages).length !== 1;
      if (!_this10.state.show_languages) {
        _this10.props.setLanguage(_this10.state.language_id);
      }
      _this10.setState({ survey_id: _this10.state.tmp_survey, tmp_survey: 0, current_move: 'forward' });
    });
  };

  Survey.prototype.handleNextButtonClick = function handleNextButtonClick() {
    var _this11 = this;

    this.state.seq_no = this.state.seq_no + 1;
    this.state.show_search_page = false;
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_BTN_CLICK, _utilElement.EVENT_BTN_CLICK, 'Next button clicked.');
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 1000);
    if (this.state.tmp_location) {
      if (this.state.location_id && !parseInt(this.props.params.surveyId, 10)) {
        this.loadSurveyList();
      } else if (this.state.location_id && parseInt(this.props.params.surveyId, 10)) {
        this.props.loadSurvey(this.props.params.clientId, this.state.survey_id, this.state.location_id, this.state.audience_code ? this.state.audience_code : '').then(function (surveyData) {
          if (surveyData && surveyData.data) {
            _this11.configureSurvey(surveyData.data);
          }
          _this11.state.show_locations = false;
          _this11.state.show_surveys = false;
          _this11.state.show_languages = _this11.props.survey && (0, _keys2.default)(_this11.props.survey.data.languages).length !== 1;
          if (!_this11.state.show_languages) {
            _this11.props.setLanguage(_this11.state.language_id);
          }
          _this11.setState({ location_id: _this11.state.tmp_location, tmp_location: 0, survey_id: parseInt(_this11.props.params.surveyId, 10), tmp_survey: 0, current_move: 'forward' });
        });
      } else {
        this.state.show_locations = false;
        this.state.show_surveys = !this.defaultSurveyId() && this.props.surveys && this.props.surveys.length !== 1;
        this.state.show_languages = this.defaultSurveyId() && this.props.survey && (0, _keys2.default)(this.props.survey.data.languages).length !== 1;
        this.setState({ location_id: this.state.tmp_location, tmp_location: 0, current_move: 'forward' });
      }
    }
    if (this.state.tmp_survey) {
      if (this.state.survey_id) {
        this.loadSurveyInfo();
      } else {
        this.state.show_locations = false;
        this.state.show_surveys = false;
        this.state.show_languages = this.props.survey && (0, _keys2.default)(this.props.survey.data.languages).length !== 1;
        if (!this.state.show_languages) {
          this.props.setLanguage(this.state.language_id);
        }
        this.setState({ survey_id: this.state.tmp_survey, tmp_survey: 0, current_move: 'forward' });
      }
    }
    if (this.state.tmp_language) {
      this.state.show_locations = false;
      this.state.show_surveys = false;
      this.state.show_languages = false;
      this.props.setLanguage(this.state.tmp_language);
      this.setState({ language_id: this.state.tmp_language, tmp_language: 0, current_move: 'forward' });
    }
  };

  Survey.prototype.handleBackButtonClick = function handleBackButtonClick() {
    this.state.show_search_page = false;
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_BTN_CLICK, _utilElement.EVENT_BTN_CLICK, 'Back button clicked.');
    window.scrollTo(0, 0);
    this.state.seq_no = this.state.seq_no - 1;
    if (this.state.current_page === 'language') {
      if (!this.defaultSurveyId()) {
        this.setState({ show_languages: false, show_locations: false, show_surveys: true, tmp_language: 0, current_page: 'survey', current_move: 'backward' });
      } else if (this.defaultSurveyId() && !this.defaultLocationId()) {
        this.setState({ show_languages: false, show_locations: true, show_surveys: false, tmp_language: 0, current_page: 'location', current_move: 'backward' });
      } else {
        this.setState({ tmp_language: 0, current_move: 'backward' });
      }
    }
    if (this.state.current_page === 'survey') {
      if (!this.defaultLocationId()) {
        this.setState({ tmp_language: false, show_languages: false, show_locations: true, show_surveys: false, tmp_survey: 0, current_page: 'location', current_move: 'backward' });
      } else {
        this.setState({ tmp_survey: 0, current_move: 'backward' });
      }
    }
  };

  Survey.prototype.handleSearchClickMobile = function handleSearchClickMobile() {
    this.setState({ show_search_page: true });
  };

  Survey.prototype.render = function render() {
    this.state.show_loading = this.props.apiRouter.loadingSurveys || this.props.apiRouter.loadingSurvey || this.props.apiRouter.loadingLocations || this.props.apiRouter.loadingProviders || this.props.apiRouter.loadingAudienceInfo || this.props.apiRouter.savingSurvey ? true : false;
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.survey_page_container, style: { height: this.state.height }, id: 'customTheme' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Survey' }),
        _react2.default.createElement(_mozart_ui.MozartLoading, {
          id: 'loading',
          loading: this.state.show_loading }),
        this.props.clientDetails && this.props.clientDetails.loadedClient ? _react2.default.createElement(
          'div',
          { className: this.styles.survey_body_container },
          (!this.state.location_id || !this.state.survey_id || !this.state.language_id) && !this.state.show_thankyou ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.SurveyHeader, { params: this.props.params, clientLogoUrl: this.state.client_logo_url, theme: this.state.theme }),
            _react2.default.createElement(
              _reactAddonsCssTransitionGroup2.default,
              { transitionName: this.state.current_move === 'forward' ? 'survey-page-top' : 'survey-page-bottom' },
              this.getPrePageContent()
            ),
            _react2.default.createElement(_components.SurveyFooter, {
              showBack: this.state.show_back,
              showNext: this.state.show_next,
              theme: this.state.theme,
              onNextClick: this.handleNextButtonClick.bind(this),
              onBackClick: this.handleBackButtonClick.bind(this),
              onSearchClick: this.handleSearchClickMobile.bind(this)
            })
          ) : null,
          !this.state.show_thankyou && this.state.location_id && this.state.survey_id && this.state.language_id && !this.state.start_survey ? _react2.default.createElement(_components.SurveyHome, {
            onStartSurvey: this.startSurvey.bind(this),
            params: this.props.params,
            clientLogoUrl: this.state.client_logo_url,
            showBranding: this.state.show_branding,
            theme: this.state.theme
          }) : null,
          !this.state.show_thankyou && this.state.location_id && this.state.survey_id && this.state.language_id && this.state.start_survey && !this.state.show_languages ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.SurveyHeader, { params: this.props.params, clientLogoUrl: this.state.client_logo_url, theme: this.state.theme }),
            _react2.default.createElement(_components.SurveyQuestions, {
              key: 'test',
              locationId: this.state.location_id,
              providerId: this.state.provider_id,
              surveyId: this.state.survey_id,
              params: this.props.params,
              onSubmit: this.onSurveySubmit.bind(this),
              previewMode: this.state.preview_mode,
              theme: this.state.theme
            })
          ) : null,
          this.state.show_thankyou ? _react2.default.createElement(_components.Thankyou, { code: this.state.audience_code,
            params: this.props.params,
            redirectFromThankyou: this.state.redirect_from_thankyou,
            showBranding: this.state.show_branding,
            clientLogoUrl: this.state.client_logo_url,
            previewMode: this.state.preview_mode,
            surveySubmitted: this.state.survey_submitted,
            theme: this.state.theme
          }) : null
        ) : ''
      )
    );
  };

  return Survey;
}(_react.Component), _class2.propTypes = {
  loadSurvey: _react.PropTypes.func,
  loadClient: _react.PropTypes.func,
  loadLanguages: _react.PropTypes.func,
  setLanguage: _react.PropTypes.func,
  loadLocations: _react.PropTypes.func,
  loadSurveys: _react.PropTypes.func,
  saveFeedback: _react.PropTypes.func,
  loadAudienceInfo: _react.PropTypes.func,

  params: _react.PropTypes.object,
  locations: _react.PropTypes.object,
  surveys: _react.PropTypes.object,
  survey: _react.PropTypes.object,
  clientDetails: _react.PropTypes.object,
  apiRouter: _react.PropTypes.object,
  location: _react.PropTypes.object,
  selectedLanguage: _react.PropTypes.string
}, _temp)) || _class);
exports.default = Survey;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Survey/Survey.js
// module id = 2305
// module chunks = 0